import { AntTag } from '@agro-club/agroclub-shared'
import { ApprovalStatus, isApprovalStatusAfter, ListDeal } from 'modules/domain/deal/types'
import { FC } from 'react'
import { IconTrack } from '../../Board/styled'
import { useTranslation } from 'react-i18next'

interface Props {
  deal: ListDeal
}

export const LogisticianManagerFinalTag: FC<Props> = ({ deal }) => {
  const { t } = useTranslation('deal')
  const approvalStatus = deal.approval_status
  const approvalIsOk = isApprovalStatusAfter(approvalStatus, ApprovalStatus.APPROVED_BY_LOGISTICIANS)

  return (
    <AntTag icon={<IconTrack $approve={approvalIsOk} />} color={approvalIsOk ? 'blue' : 'grey'}>
      {t('logisticianManager')}
    </AntTag>
  )
}
